import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import axios from "axios";
import { clientAccess } from "../../utils/index";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import TopHeader from "../../layout/TopHeader";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const YearArr = [];

for (var i = 2015; i <= 2030; i++) {
  YearArr.push(i)
}

class AcquisitionDetails extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    value: [],
    redirect: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    disableOnEdit: false,
    delete: false,
    currentIndex: null,
    showFirstAddBtn: true,
    url: `${apiUrl.apiUrl.url}/close-deal/create`,
    id: undefined,
    initialValues: {
      groupId: "",
      groupName: "",
      clientId: "",
      clientName: "",
      asset_name: "",
      asset_type: "",
      // deal_type: "", 
      value: "",
      net_entry_yield: "",
      effective_date: "",
      gross_entry_yield: "",
    },
  };

  resetForm(values) {
    this.state.initialValues = {};

    values.groupId = "";
    values.groupName = "";
    values.clientId = "";
    values.clientName = "";
    values.asset_name = "";
    values.asset_type = "";
    values.construction_cost = "";
    values.net_purchase_price = "";
    values.purchase_price = "";
    values.gross_purchase_price = "";
    values.net_purchase_price = "";
    values.net_entry_yield = "";
    values.gross_entry_yield = "";
    values.acquisition_date = "";
    values.effective_date = "";
    values.sale_deed_date = "";

    values.showFirstAddBtn = true;
    this.setState({});
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log(this.props.match.params.id, "abc");
    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-asset-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }


  changeCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + countryid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeState = (e) => {
    let stateId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/districts/state-districts/` + stateId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          districts: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCityId(e) {
    this.state.cityId = e.target.value;
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this deal",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/close-deal/create`,
          initialValues: {
            groupId: "",
            groupName: "",
            clientId: "",
            clientName: "",
            asset_name: "",
            asset_type: "",
            // deal_type: "",
          },
        });
      } else {
        fetch(
          `${apiUrl.apiUrl.url}/close-deal/fetch-close-deal?id=${this.props.match.params.id}`,
          {headers}
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log(data.data, "data.data");
            this.setState({
              url: `${apiUrl.apiUrl.url}/close-deal/update?id=${this.props.match.params.id}`,
              initialValues: data.data,
              LandlordGroups: data.LandlordGroups,
              clientList: data.clientList,
            });
            this.state.initialValues.groupId = data.other_data.groupId;
            this.state.initialValues.groupName = data.other_data.groupName;
            this.state.initialValues.clientId = data.other_data.clientId;
            this.state.initialValues.clientName = data.other_data.clientName;
            this.setState({});
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/close-deal/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };
  redirectToClose = () => {
    this.setState({ delete: false });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        asset_type: "",
        // deal_type: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        groupId: "",
        groupName: "",
        clientId: "",
        clientName: "",
        asset_name: "",
        asset_type: "",
        // deal_type: "",
      },
    });
  };


  year = () => {
    const arr = [];


    for (let i = 0; i < 10; i++) {
      arr.push(<option>{i}</option>);
    }
    return <div>year</div>
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to={"/close-deals/asset-management/" + this.state.id} />;

    }
    return (
      <div className="parentContainer">
        <>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li><Link to="/close-deals">Close Deals</Link></li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Acquisition Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              // values.assetTypeId = this.state.initialValues.assetTypeId;
              // values.assetId = this.state.initialValues.assetId;
              // values.subAssetId = this.state.initialValues.subAssetId;
              console.log(values);
              var self = this;
              axios({
                method: "post",
                url: this.state.url,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({
                    messsagePopup: true,
                    popupContent: "Data Saved Successfully!",
                  });
                }
              });
            }}
          >
            {
              ({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Asset Type <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly="true" name="asset_type" />
                              <ErrorMessage
                                name="asset_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field type="text" readOnly="true" name="asset_name" />
                              <ErrorMessage
                                name="asset_name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Purchase Price
                            </label>
                            <div className="position-relative">
                              <Field type="number" name="purchase_price" />
                              <ErrorMessage
                                name="purchase_price"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Construction Cost
                            </label>
                            <div className="position-relative">
                              <Field type="number" name="construction_cost" />
                              <ErrorMessage
                                name="construction_cost"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Gross Purchase Price{" "}
                            </label>
                            <div className="position-relative">
                              <Field type="number" name="gross_purchase_price" />
                              <ErrorMessage
                                name="gross_purchase_price"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Net Purchase Price
                            </label>
                            <div className="position-relative">
                              <Field type="number" name="net_purchase_price" />
                              <ErrorMessage
                                name="net_purchase_price"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Gross Entry Yield
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="gross_entry_yield" />
                              <ErrorMessage
                                name="gross_entry_yield"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Net Entry Yield
                            </label>
                            <div className="position-relative">
                              <Field type="text" name="net_entry_yield" />
                              <ErrorMessage
                                name="net_entry_yield"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Acquisition Date
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="acquisition_date" />
                              <ErrorMessage
                                name="acquisition_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Effective Date
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="effective_date" />
                              <ErrorMessage
                                name="effective_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Sale Deed Date
                            </label>
                            <div className="position-relative">
                              <Field type="date" name="sale_deed_date" />
                              <ErrorMessage
                                name="sale_deed_date"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                        {this.props.match.params.id !== undefined ? (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="update_button" disabled={isSubmitting}>
                              Update
                            </button>
                            <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                              <Link to="/close-deals/acquisition-details">
                                Reset
                              </Link>
                            </button>
                          </div>
                        ) : (
                          <div className="newGridSectionInner button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                            <button type="submit" className="add_button" disabled={isSubmitting}>
                              Add
                            </button>
                            <button type="reset" className="reset_button">
                              <Link
                                to="/close-deals/acquisition-details"
                                onClick={(e) => {
                                  this.resetForm(values);
                                }}
                              >
                                Reset
                              </Link>
                            </button>
                          </div>
                        )}

                      </div>
                    </Form>
                  </div>
                </>
              )}
          </Formik>
          <PopupMessage
            open={this.state.messsagePopup}
            content={this.state.popupContent}
            redirectAfterSave={this.redirectAfterSave}
          />
          <Popup open={this.state.delete} position="top center">
            {(close) => (
              <div>
                "Delete the item?"
                <a className="close" onClick={this.redirectToClose}>
                  &times;
                </a>
                <div>
                  <button type="button" onClick={this.redirectToDelete}>
                    Yes
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </>
      </div>

    );
  }
}

export default withRouter(AcquisitionDetails);